function isValidJson(jsonString) {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (error) {
    console.error("Invalid JSON:", error);
    return false;
  }
}

export default isValidJson;
